import { render, staticRenderFns } from "./wxTagPicker.vue?vue&type=template&id=6995c9f6&scoped=true&"
import script from "./wxTagPicker.vue?vue&type=script&lang=js&"
export * from "./wxTagPicker.vue?vue&type=script&lang=js&"
import style0 from "./wxTagPicker.vue?vue&type=style&index=0&id=6995c9f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6995c9f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6995c9f6')) {
      api.createRecord('6995c9f6', component.options)
    } else {
      api.reload('6995c9f6', component.options)
    }
    module.hot.accept("./wxTagPicker.vue?vue&type=template&id=6995c9f6&scoped=true&", function () {
      api.rerender('6995c9f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/picker/wxTagPicker.vue"
export default component.exports